import { useMemo, useState } from 'react';
import { Tab, TabProps } from 'react-admin';
import { OverrideLogicForm } from '@/pages/Candidate/view/forms';
import { ActionsButtonStyled } from './styled';
import Table from './Table';

const CriminalRecordsTab = (props: Partial<TabProps>) => {
  const [showOverrideForm, setShowOverrideForm] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const cannotOverride = useMemo(() => selectedIds.length === 0, [selectedIds]);

  const handleRecordSelect = (id: string) =>
    setSelectedIds((prev) => (prev.includes(id) ? prev.filter((selectedId) => selectedId !== id) : [...prev, id]));

  const closeOverrideForm = () => {
    setShowOverrideForm(false);
    setSelectedIds([]);
  };

  return (
    <Tab label="County" {...props}>
      {showOverrideForm ? (
        <OverrideLogicForm onClose={closeOverrideForm} selectedIds={selectedIds} />
      ) : (
        <>
          <ActionsButtonStyled
            iconType="addCircleOutline"
            label="Override Logic"
            onClick={() => setShowOverrideForm(true)}
            disabled={cannotOverride}
          />
          <Table onRecordSelect={handleRecordSelect} selectedIds={selectedIds} />
        </>
      )}
    </Tab>
  );
};

export default CriminalRecordsTab;
